import React from 'react';

//Material UI
import Zoom from '@mui/material/Zoom';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import DialogActions from "@mui/material/DialogActions";

//Components
import Modal from '../index'
import Spinner from '../../spinner'

const Transition = React.forwardRef((props, ref) => <Zoom ref={ref} {...props} />);

const ModalConfirm = ({
    open,
    title,
    message,
    maxWidthModal = 'xs',
    cancelText = 'cancelar',
    acceptText = 'aceptar',
    onAccept,
    onCancel,
    onClose,
    loading,
    ...rest
}) =>
    <Modal
        open={open}
        title={title}
        onClose={onClose}
        {...rest}
        maxWidth={maxWidthModal}
        disableEscapeKeyDown
        TransitionComponent={Transition}
        dividers
        customButtons={() =>
            <DialogActions>
                <Button
                    onClick={onCancel}
                    color="primary"
                    variant='outlined'
                    disabled={loading}
                    autoFocus
                >
                    {cancelText}
                </Button>
                <Button
                    onClick={onAccept}
                    color="primary"
                    variant="contained"
                    disabled={loading}
                >
                    {acceptText}
                </Button>
            </DialogActions>
        }
    >
        {loading && <Spinner lockScreen message='Procesando' />}
        <Typography variant="body1">{message}</Typography>
    </Modal>

export default ModalConfirm;